import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useSocketStore from "../../stores/socket.js";
import usePartyStore from "../../stores/party.js";
import { log } from "@tumbodash/browserPackages";
import Main from "./main.js";
import type { Party } from "../../types.js";

function PartyView() {
	const socket = useSocketStore((s) => s.socket);
	const party = usePartyStore((s) => s.party);
	const updateParty = usePartyStore.getState().updateParty;
	const { partyId } = useParams<{ partyId: string }>();

	useEffect(() => {
		if (!socket) return;

		const handleParty = (payload: { data: Party & { socketIndex: Record<string, string> } }) => {
			const { data } = payload;
			data.activePlayerId = data.socketIndex[socket.id!];
			updateParty(data);
		};

		const handleResetParty = () => {
			socket.emit("party:join", { data: { partyId }, code: 55782 });
		};

		socket.on("party", handleParty);
		socket.on("resetParty", handleResetParty);

		return () => {
			log.socket("Cleaning up party socket listeners...");
			socket.off("party", handleParty);
			socket.off("resetParty", handleResetParty);
		};
	}, [socket]);

	useEffect(() => {
		if (!socket) return;
		log.socket("Joining Party: " + partyId);
		socket.emit("party:join", { data: { partyId }, code: 83422 });
	}, [socket, partyId]);

	return party != null ? (
		<Main key={partyId} />
	) : (
		<div style={{
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			minHeight: "100dvh",
			color: "var(--text-muted)",
			fontSize: "0.9rem",
			fontWeight: 600,
			letterSpacing: "0.04em",
		}}>Joining Party…</div>
	);
}

export default PartyView;
